// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/straight-tuck-end-template.svg'

export const StraightTuckEndTemplate = (
  props: React.SVGProps<SVGSVGElement>
) => {
  return <TemplateSVG {...props} />
}
